module.exports = {
  INFO: "info",
  SUCCESS: "success",
  WARNING: "warning",
  ALERT: "alert",
};
